import React, { useEffect, useState } from "react";
import {
  Modal,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
  Image,
  Dimensions,
} from "react-native";
import { ProgressBar } from "react-native-paper";
import { AppColors } from "../../../../utility/AppColors";
import Ionicons from "@expo/vector-icons/Ionicons";
import { AppImages } from "../../../../utility/AppImages";
import { useNotificationDetailsPopupStyles } from "../Notifications/NotificationPopup/notificationDetailsPopupStyles";
import NotificationHeaderSkeleton from "../../../../Components/skeleton-components/NotificationHeaderSkeleton";
import NotificationDetailsRowSkeleton from "../../../../Components/skeleton-components/NotificationDetailsRowSkeleton";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import { Base64 } from "js-base64";
import ImageComponent from "../../../../Components/ImageComponent";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import { format, isValid } from "date-fns";
import { getEventForNotLoginUser } from "../../../../services/eventsAPI";
import { toast } from "react-toastify";
import Avatar from "../../../../Components/choose-avatar-components/Avatar";
import { Badge } from "../../../../Components/notification-common-components/Badge";
import Skeletons from "../../../../Components/skeleton-components/Skeletons";
import {
  parseEventShareURL,
  storeEventShareAction,
} from "../../../../utility/urlUtils";
import { useUserData } from "../../../../context/UserDataContext";
import { useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../../../utility/NavigationHelper";
import { AppScreens } from "../../../Utility/AppScreens";
import { base_url, endpoints } from "../../../../Api/configs";
import { storeUserActivity, ACTIVITY_TYPES } from "../../../../services/activityService";

export function EventSharePopup(props) {
  const {
    showModal = false,
    setShowModal,
    onActionPress,
    eventShareURL = null,
    eventId = null,
  } = props;

  const deviceSize = useDeviceSize();
  const navigation = useNavigation();
  const { userData } = useUserData();
  const [showCreateLoader, setCreateShowLoader] = useState(false);
  const [eventDetails, setEventDetails] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  const [isNegotiating, setIsNegotiating] = useState(false);
  const styles = useNotificationDetailsPopupStyles();
  const screenWidth = Dimensions.get("window").width;

  useEffect(() => {
    if (showModal) {
      fetchEventDetailsFromURL();
    }
  }, [showModal]);

  useEffect(() => {
    console.log("🔄 EventDetails state changed:", eventDetails);
  }, [eventDetails]);

  const fetchEventDetailsFromURL = () => {
    try {
      console.log("🔍 EventSharePopup received eventId prop:", eventId);
      console.log("🔍 EventSharePopup received eventShareURL prop:", eventShareURL);

      let extractedEventId = eventId;

      if (!extractedEventId && eventShareURL) {
        console.log("🔍 Parsing eventShareURL:", eventShareURL);
        const urlData = parseEventShareURL(eventShareURL);
        extractedEventId = urlData.eventId;
        console.log(
          "🎯 Extracted eventId from eventShareURL:",
          extractedEventId
        );
      }

      if (!extractedEventId) {
        console.log(
          "🔍 Fallback: trying to parse current URL:",
          window.location.href
        );
        const urlParams = new URLSearchParams(window.location.search);
        const sessionParam = urlParams.get("session");
        console.log("📍 Session param from current URL:", sessionParam);

        if (sessionParam) {
          const decodedSession = Base64.decode(sessionParam);
          const sessionData = JSON.parse(decodedSession);
          extractedEventId = sessionData.eventId;
          console.log(
            "🎯 Extracted eventId from current URL:",
            extractedEventId
          );
        }
      }

      if (extractedEventId) {
        console.log("✅ Calling API with eventId:", extractedEventId);
        callGetEventDetails(extractedEventId);
      } else {
        console.error("❌ No eventId found");
        toast.error("Event ID not found");
        setShowModal(false);
      }
    } catch (error) {
      console.error("❌ Error parsing event data:", error);
      toast.error("Invalid event link");
      setShowModal(false);
    }
  };

  const callGetEventDetails = async (eventId) => {
    setCreateShowLoader(true);

    try {
      const response = await getEventForNotLoginUser(eventId);
      console.log("🎯 API Response:", response.event);
      if (response.event) {
        // The API response has the event data nested under 'event' property
        const eventData = response.event;
        console.log("📊 Setting event data:", eventData);
        console.log("📊 Event data type:", typeof eventData);
        console.log("📊 Event data keys:", Object.keys(eventData || {}));
        setEventDetails(eventData);
        console.log("✅ setEventDetails called with:", eventData);
      } else {
        toast.error("Failed to fetch event details");
        setShowModal(false);
      }
    } catch (error) {
      console.error("❌ API Error:", error);
      toast.error("Failed to fetch event details");
      setShowModal(false);
    } finally {
      setCreateShowLoader(false);
    }
  };

  const onCloseClick = () => {
    setShowModal(false);
  };

  const handleActionPress = async (action) => {
    // Handle negotiate action differently
    if (action === "negotiate") {
      await handleNegotiateTerms();
      return;
    }

    storeEventShareAction(action);

    const signupFlowContextStr = sessionStorage.getItem("signupFlowContext");
    if (signupFlowContextStr) {
      try {
        const signupFlowContext = JSON.parse(signupFlowContextStr);
        signupFlowContext.notificationAction = action;
        sessionStorage.setItem(
          "signupFlowContext",
          JSON.stringify(signupFlowContext)
        );
        console.log(
          "💾 EventSharePopup: Updated signupFlowContext notificationAction to:",
          action
        );
      } catch (error) {
        console.warn(
          "⚠️ EventSharePopup: Error updating signupFlowContext:",
          error
        );
      }
    }

    if (onActionPress) {
      onActionPress(action);
    }
    setShowModal(false);
  };

  const handleNegotiateTerms = async () => {
    // Check if user is logged in
    if (!userData || !userData.AccessToken) {
      toast.info("Please log in to negotiate terms");
      storeEventShareAction("negotiate");
      setShowModal(false);
      navigateToScreen(navigation, AppScreens.LoginScreen);
      return;
    }

    setIsNegotiating(true);
    try {
      // Call negotiate terms API
      const response = await fetch(
        `${base_url}${endpoints.events.negotiateTerms}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userData.AccessToken}`,
          },
          body: JSON.stringify({
            accessToken: userData.AccessToken,
            eventId: eventDetails?.eventID,
            newOpponentId: userData.username || userData.userID,
          }),
        }
      );

      const result = await response.json();

      if (response.ok) {
        // Check if response has message indicating success
        if (result.message || result.chatId) {
          toast.success("Terms negotiated successfully");

          // Track activity FIRST before redirect (fire and forget)
          storeUserActivity(
            userData.AccessToken,
            eventDetails?.eventID,
            ACTIVITY_TYPES.NEGOTIATION_STARTED
          ).catch((err) => console.warn("Failed to track activity:", err));

          setShowModal(false);

          // Redirect to ongoing events chat tab
          navigateToScreen(navigation, AppScreens.OnGoingEvents, {
            eventID: eventDetails?.eventID,
            tab: "Chat",
          });
        } else {
          const errorMessage = result.error || "Failed to negotiate terms";
          toast.error(errorMessage);
        }
      } else {
        const errorMessage = result.error || "Failed to negotiate terms";
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error("Error negotiating terms:", error);
      toast.error("Failed to negotiate terms. Please try again.");
    } finally {
      setIsNegotiating(false);
    }
  };

  const IsPrivateEvent = eventDetails?.eventType === "Exclusive";

  console.log("🔍 Current render - EventDetails:", eventDetails);
  console.log("🔍 Current render - IsPrivateEvent:", IsPrivateEvent);
  console.log("🔍 Current render - showCreateLoader:", showCreateLoader);

  const beltData = (eventDetails?.stakes ?? [])
    .filter((stake) => stake.quantity > 0)
    .map((stake) => {
      let beltImage;
      let beltText;

      switch (stake.type) {
        case "Token":
        case "Coin": // API uses "Coin" instead of "Token"
          beltImage = AppImages.icCoinBelt;
          beltText = "Token";
          break;
        case "Bronze":
          beltImage = AppImages.icBronzeBelt;
          beltText = "Bronze";
          break;
        case "Silver":
          beltImage = AppImages.icSilverBelt;
          beltText = "Silver";
          break;
        case "Gold":
          beltImage = AppImages.icGoldBelt;
          beltText = "Gold";
          break;
        case "Platinum":
          beltImage = AppImages.icPlatinumBelt;
          beltText = "Platinum";
          break;
        default:
          beltImage = AppImages.icCoinBelt;
          beltText = "Token";
      }

      return {
        beltImage,
        beltText,
        amount: stake.quantity,
      };
    });

  const formatDate = (date) => {
    const eventDate = new Date(date);

    if (!isValid(eventDate)) {
      return "Invalid date";
    }

    return format(eventDate, "EEEE, MMMM d, yyyy, 'at' h:mm a");
  };

  const calculateProgress = (won, total) => {
    if (total === 0) return 0;
    return won / total;
  };

  const TitleDetailView = ({ title, description }) => (
    <View style={styles.titleDetailWrapper}>
      <Text style={styles.titleText}>{title}</Text>
      <Text style={styles.descriptionText}>{description}</Text>
    </View>
  );

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={showModal}
      onRequestClose={() => { }} // Disable close on back button
    >
      <View style={styles.container}>
        <View style={styles.mainView}>
          <View style={styles.header}>
            {showCreateLoader ? (
              <NotificationHeaderSkeleton />
            ) : (
              <>
                <View
                  style={{
                    display: "flex",
                    flexDirection:
                      deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                        ? "column"
                        : "row",
                    gap: 20,
                  }}
                >
                  <Image
                    source={AppImages.icNotificationLogo}
                    style={{ height: 75, width: 110 }}
                    resizeMode="contain"
                  />
                  {deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? (
                    <Image
                      source={AppImages.icNotificationBarcode}
                      style={{ height: 50, width: 425, marginTop: 15 }}
                    />
                  ) : null}
                  {deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM ? null : IsPrivateEvent ? (
                      <Image
                        source={AppImages.icExclusiveEvent}
                        style={{
                          width: 72,
                          height: 72,
                        }}
                        resizeMode="contain"
                      />
                    ) : null}
                </View>
                {/* No close icon for event share popup */}
              </>
            )}
          </View>

          {deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS ? (
            <Image
              source={AppImages.icNotificationBarcode}
              style={{ height: 35, width: "100%", marginTop: 15 }}
            />
          ) : null}
          <View style={styles.separator} />

          <ScrollView showsVerticalScrollIndicator={false}>
            {showCreateLoader ? (
              <NotificationDetailsRowSkeleton />
            ) : (
              <>
                {/* First Section - Event Details - Exact copy from NotificationDetails */}
                <View
                  style={{
                    backgroundColor: AppColors.purple_453B50,
                    display: "flex",
                    flexDirection:
                      deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                        ? "column"
                        : "row",
                    justifyContent:
                      deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                        ? null
                        : "space-between",
                    alignItems: "center",
                    padding: 10,
                    borderRadius: 10,
                    gap:
                      deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                        ? 10
                        : null,
                    marginBottom: 10,
                  }}
                >
                  <View
                    style={{
                      backgroundColor: "#302936",
                      padding: 10,
                      borderRadius: 10,
                      position: "relative",
                      overflow: "hidden",
                    }}
                  >
                    {/* Kaller Tag */}
                    <Badge title={"Kaller"} />

                    <Avatar
                      src={eventDetails?.organiserProfilePicture}
                      variant="full"
                    />
                    <View
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        marginTop: 5,
                      }}
                    >
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_12,
                          {
                            color: AppColors.white,
                            alignSelf: "center",
                          },
                        ]}
                      >
                        Game won
                      </Text>
                      <Text
                        style={[
                          AppFontStyle.BOLD_ANYBODY_12,
                          {
                            color: AppColors.white,
                            alignSelf: "center",
                          },
                        ]}
                      >
                        {eventDetails?.participantProfiles?.[0]
                          ?.gamesWonCount || 0}
                      </Text>
                    </View>
                    <View>
                      <ProgressBar
                        progress={calculateProgress(
                          eventDetails?.participantProfiles?.[0]
                            ?.gamesWonCount || 0,
                          eventDetails?.participantProfiles?.[0]
                            ?.playedGamesCount || 1
                        )}
                        color={AppColors.green_44aeb4}
                        style={{
                          marginTop: 5,
                          height: 8,
                          borderRadius: 3,
                          backgroundColor: AppColors.black,
                        }}
                      />
                    </View>
                    <View
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        marginTop: 10,
                      }}
                    >
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_12,
                          {
                            color: AppColors.white,
                            alignSelf: "center",
                          },
                        ]}
                      >
                        Played Games
                      </Text>
                      <Text
                        style={[
                          AppFontStyle.BOLD_ANYBODY_12,
                          {
                            color: AppColors.white,
                            alignSelf: "center",
                          },
                        ]}
                      >
                        {eventDetails?.participantProfiles?.[0]
                          ?.playedGamesCount || 0}
                      </Text>
                    </View>
                  </View>
                  <View
                    style={{
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_16,
                        {
                          color: AppColors.white,
                        },
                      ]}
                    >
                      <Text
                        style={[
                          AppFontStyle.BOLD_ANYBODY_16,
                          {
                            color: AppColors.white,
                          },
                        ]}
                      >
                        {eventDetails?.organiserId} {""}
                      </Text>
                      has challenged you in
                    </Text>
                    <Text
                      style={[
                        AppFontStyle.BOLD_ANYBODY_16,
                        {
                          color: AppColors.white,
                        },
                      ]}
                    >
                      {eventDetails?.gameTitle}
                    </Text>
                    <Text
                      style={[
                        AppFontStyle.BOLD_ANYBODY_16,
                        {
                          color: AppColors.white,
                          marginVertical: 10,
                        },
                      ]}
                    >
                      Will start on:
                    </Text>

                    <View
                      style={{
                        backgroundColor: AppColors.yellow_b69200,
                        borderRadius: 5,
                      }}
                    >
                      <Text
                        style={[
                          deviceSize === DEVICE_SIZES.XS ||
                            deviceSize === DEVICE_SIZES.SM
                            ? AppFontStyle.BOLD_ANYBODY_14
                            : AppFontStyle.BOLD_ANYBODY_16,
                          {
                            color: AppColors.white,
                            padding: 5,
                          },
                        ]}
                      >
                        {formatDate(eventDetails?.eventStartTime) ||
                          "Not Specified"}
                      </Text>
                    </View>
                  </View>
                  {IsPrivateEvent ? (
                    <View style={{ gap: 12 }}>
                      <Text
                        style={[
                          AppFontStyle.BOLD_ANYBODY_24,
                          { textAlign: "center", color: AppColors.white },
                        ]}
                      >
                        Join this challenge
                      </Text>
                      <View style={{ flexDirection: "row", gap: 20 }}>
                        <View
                          style={{
                            gap: 3,
                          }}
                        >
                          <Text
                            style={[
                              AppFontStyle.REGULAR_ANYBODY_12,
                              {
                                color: AppColors.white,
                              },
                            ]}
                          >
                            Event Type
                          </Text>
                          <View
                            style={{
                              backgroundColor: AppColors.black,
                              alignItems: "center",
                              justifyContent: "center",
                              padding: 10,
                              borderRadius: 5,
                            }}
                          >
                            <Text
                              style={[
                                AppFontStyle.BOLD_ANYBODY_14,
                                {
                                  color: AppColors.white,
                                },
                              ]}
                            >
                              {eventDetails?.eventType === "Public"
                                ? "Kall-Out"
                                : "Exclusive"}
                            </Text>
                          </View>
                        </View>
                        <View
                          style={{
                            gap: 3,
                          }}
                        >
                          <Text
                            style={[
                              AppFontStyle.REGULAR_ANYBODY_12,
                              {
                                color: AppColors.white,
                              },
                            ]}
                          >
                            Play Type
                          </Text>
                          <View
                            style={{
                              backgroundColor: AppColors.black,
                              alignItems: "center",
                              justifyContent: "center",
                              padding: 10,
                              borderRadius: 5,
                            }}
                          >
                            <Text
                              style={[
                                AppFontStyle.BOLD_ANYBODY_14,
                                {
                                  color: AppColors.white,
                                },
                              ]}
                            >
                              1 vs 1
                            </Text>
                          </View>
                        </View>
                        <View
                          style={{
                            gap: 3,
                          }}
                        >
                          <Text
                            style={[
                              AppFontStyle.REGULAR_ANYBODY_12,
                              {
                                color: AppColors.white,
                              },
                            ]}
                          >
                            Game
                          </Text>
                          <View
                            style={{
                              backgroundColor: AppColors.black,
                              alignItems: "center",
                              justifyContent: "center",
                              padding: 10,
                              borderRadius: 5,
                            }}
                          >
                            <Text
                              style={[
                                AppFontStyle.BOLD_ANYBODY_14,
                                {
                                  color: AppColors.white,
                                },
                              ]}
                            >
                              {eventDetails?.gameTitle}
                            </Text>
                          </View>
                        </View>
                      </View>
                      <View style={{ flexDirection: "row", gap: 20 }}>
                        <View
                          style={{
                            gap: 3,
                          }}
                        >
                          <Text
                            style={[
                              AppFontStyle.REGULAR_ANYBODY_12,
                              {
                                color: AppColors.white,
                              },
                            ]}
                          >
                            Device
                          </Text>
                          <View
                            style={{
                              backgroundColor: AppColors.black,
                              alignItems: "center",
                              justifyContent: "center",
                              padding: 10,
                              borderRadius: 5,
                            }}
                          >
                            <Text
                              style={[
                                AppFontStyle.BOLD_ANYBODY_14,
                                {
                                  color: AppColors.white,
                                },
                              ]}
                            >
                              {eventDetails?.device || "PC"}
                            </Text>
                          </View>
                        </View>
                        <View
                          style={{
                            gap: 3,
                          }}
                        >
                          <Text
                            style={[
                              AppFontStyle.REGULAR_ANYBODY_12,
                              {
                                color: AppColors.white,
                              },
                            ]}
                          >
                            Gamer id
                          </Text>
                          <View
                            style={{
                              backgroundColor: AppColors.black,
                              alignItems: "center",
                              justifyContent: "center",
                              padding: 10,
                              borderRadius: 5,
                            }}
                          >
                            <Text
                              style={[
                                AppFontStyle.BOLD_ANYBODY_14,
                                {
                                  color: AppColors.white,
                                },
                              ]}
                            >
                              {eventDetails?.gamerID?.organiser || "N/A"}
                            </Text>
                          </View>
                        </View>
                      </View>
                    </View>
                  ) : (
                    <View
                      style={{
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <ImageComponent
                        url={eventDetails?.gameImage}
                        style={{
                          width:
                            deviceSize === DEVICE_SIZES.XS ||
                              deviceSize === DEVICE_SIZES.SM
                              ? 123
                              : 115,
                          height:
                            deviceSize === DEVICE_SIZES.XS ||
                              deviceSize === DEVICE_SIZES.SM
                              ? 141
                              : 125,
                          marginTop: 10,
                          borderRadius: 20,
                          resizeMode: "contain",
                        }}
                      />
                    </View>
                  )}
                </View>

                {/* Second Section - Stakes and Credits */}
                <View
                  style={{
                    backgroundColor: AppColors.purple_453B50,
                    padding: 10,
                    borderRadius: 10,
                    marginBottom: 10,
                    flexDirection:
                      deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                        ? "column"
                        : "row",
                    gap: 20,
                  }}
                >
                  <View style={{ flex: 1 }}>
                    <View style={{ alignItems: "center" }}>
                      <View style={styles.titleDetailWrapper}>
                        <View style={{ flexDirection: "row", gap: 10 }}>
                          {beltData.map((belt, index) => (
                            <View
                              key={index}
                              style={{
                                width: 145,
                                alignItems: "center",
                              }}
                            >
                              <View
                                style={{
                                  width:
                                    deviceSize === DEVICE_SIZES.SM ||
                                      deviceSize === DEVICE_SIZES.XS
                                      ? 100
                                      : 106,
                                  height:
                                    deviceSize === DEVICE_SIZES.SM ||
                                      deviceSize === DEVICE_SIZES.XS
                                      ? 50
                                      : 50,
                                  borderRadius: 5,
                                  borderColor: AppColors.black_161719,
                                  backgroundColor:
                                    belt.beltText === "Bronze"
                                      ? "#99633D"
                                      : belt.beltText === "Silver"
                                        ? "#9FA3A3"
                                        : belt.beltText === "Gold"
                                          ? "#DDBE6F"
                                          : belt.beltText === "Platinum"
                                            ? "#FAFFFE"
                                            : "transparent",
                                  borderWidth: 1,
                                  justifyContent: "center",
                                  alignItems: "flex-end",
                                  paddingRight: 10,
                                }}
                              >
                                <Image
                                  source={belt.beltImage}
                                  style={styles.beltImage}
                                  resizeMode="contain"
                                />
                                <View style={styles.numberContainer}>
                                  <Text style={AppFontStyle.MEDIUM_ANYBODY_18}>
                                    {belt.amount}
                                  </Text>
                                </View>
                              </View>
                            </View>
                          ))}
                        </View>
                      </View>
                    </View>
                    <View
                      style={{
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        gap: 10,
                      }}
                    >
                      <View
                        style={{
                          width:
                            deviceSize === DEVICE_SIZES.SM ||
                              deviceSize === DEVICE_SIZES.XS
                              ? 170
                              : null,
                        }}
                      >
                        <Text
                          style={[
                            deviceSize === DEVICE_SIZES.SM ||
                              deviceSize === DEVICE_SIZES.XS
                              ? AppFontStyle.REGULAR_ANYBODY_14
                              : AppFontStyle.REGULAR_ANYBODY_16,
                            {
                              color: AppColors.white,
                            },
                          ]}
                        >
                          Sign up to participate and earn:{" "}
                          <Text
                            style={[
                              deviceSize === DEVICE_SIZES.SM ||
                                deviceSize === DEVICE_SIZES.XS
                                ? AppFontStyle.BOLD_ANYBODY_16
                                : AppFontStyle.BOLD_ANYBODY_18,
                              {
                                color: AppColors.white,
                              },
                            ]}
                          >
                            {eventDetails?.totalCredits} credits
                          </Text>
                        </Text>
                        <Text
                          style={[
                            deviceSize === DEVICE_SIZES.SM ||
                              deviceSize === DEVICE_SIZES.XS
                              ? AppFontStyle.BOLD_ANYBODY_16
                              : AppFontStyle.BOLD_ANYBODY_18,
                            {
                              color: AppColors.white,
                            },
                          ]}
                        >
                          worth
                        </Text>
                      </View>
                      <View
                        style={{
                          backgroundColor: AppColors.black,
                          alignItems: "center",
                          justifyContent: "center",
                          height: 50,
                          width: 100,
                          borderRadius: 5,
                        }}
                      >
                        <Text
                          style={[
                            AppFontStyle.BOLD_ANYBODY_16,
                            {
                              color: AppColors.white,
                            },
                          ]}
                        >
                          £{eventDetails?.totalBalance}
                        </Text>
                      </View>
                    </View>
                  </View>
                  {IsPrivateEvent ? (
                    <View style={{ gap: 3, alignItems: "center" }}>
                      <Image
                        source={AppImages.icExclusiveEvent}
                        style={{
                          width: 141,
                          height: 141,
                        }}
                        resizeMode="contain"
                      />
                      <Text
                        style={[
                          AppFontStyle.MEDIUM_ANYBODY_14,
                          {
                            textAlign: "center",
                            color: AppColors.yellow_FBEBBC,
                          },
                        ]}
                      >
                        Exclusive Event
                      </Text>
                    </View>
                  ) : null}
                </View>

                {!showDetails && (
                  <View
                    style={{
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginTop: 10,
                      paddingHorizontal: 5,
                    }}
                  >
                    <TouchableOpacity
                      style={{
                        backgroundColor: AppColors.purple_453B50,
                        borderWidth: 1,
                        borderColor: AppColors.white,
                        borderRadius: 3,
                        padding: 8,
                        flexDirection: "row",
                        gap: 3,
                        alignItems: "center",
                      }}
                      onPress={() => handleActionPress("negotiate")}
                    >
                      <ImageComponent
                        url={AppImages.icNotificationMessage}
                        style={{
                          width: 20,
                          height: 20,
                        }}
                      />
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_12,
                          {
                            color: AppColors.white,
                          },
                        ]}
                      >
                        Negotiate Terms
                      </Text>
                    </TouchableOpacity>
                    <TouchableOpacity
                      style={styles.chatButton}
                      onPress={() => setShowDetails(!showDetails)}
                    >
                      <Text style={styles.chatButtonText}>
                        {showDetails
                          ? "Hide Details"
                          : "View challenge Details"}
                      </Text>
                    </TouchableOpacity>
                  </View>
                )}

                {/* Event Details Section */}
                {showDetails && (
                  <>
                    <View
                      style={{
                        backgroundColor: AppColors.purple_453B50,
                        display: "flex",
                        flexDirection: "row",
                        padding: 10,
                        borderRadius: 10,
                        marginBottom: 10,
                        justifyContent: "space-around",
                      }}
                    >
                      <View>
                        <Text
                          style={[
                            deviceSize === DEVICE_SIZES.SM ||
                              deviceSize === DEVICE_SIZES.XS
                              ? AppFontStyle.BOLD_ANYBODY_16
                              : AppFontStyle.BOLD_ANYBODY_18,
                            {
                              color: AppColors.white,
                            },
                          ]}
                        >
                          Event name:
                        </Text>
                        <Text
                          style={[
                            deviceSize === DEVICE_SIZES.SM ||
                              deviceSize === DEVICE_SIZES.XS
                              ? AppFontStyle.REGULAR_ANYBODY_14
                              : AppFontStyle.REGULAR_ANYBODY_16,
                            {
                              color: AppColors.white,
                            },
                          ]}
                        >
                          {eventDetails?.eventTitle}
                        </Text>
                      </View>
                      <View
                        style={{
                          gap: 3,
                        }}
                      >
                        <Text
                          style={[
                            AppFontStyle.REGULAR_ANYBODY_12,
                            {
                              color: AppColors.white,
                            },
                          ]}
                        >
                          Event Type
                        </Text>
                        <View
                          style={{
                            backgroundColor: AppColors.black,
                            alignItems: "center",
                            justifyContent: "center",
                            padding: 10,
                            borderRadius: 5,
                          }}
                        >
                          <Text
                            style={[
                              AppFontStyle.BOLD_ANYBODY_14,
                              {
                                color: AppColors.white,
                              },
                            ]}
                          >
                            {eventDetails?.eventType === "Public"
                              ? "Kall-Out"
                              : "Exclusive"}
                          </Text>
                        </View>
                      </View>
                      <View
                        style={{
                          gap: 3,
                        }}
                      >
                        <Text
                          style={[
                            AppFontStyle.REGULAR_ANYBODY_12,
                            {
                              color: AppColors.white,
                            },
                          ]}
                        >
                          Play Type
                        </Text>
                        <View
                          style={{
                            backgroundColor: AppColors.black,
                            alignItems: "center",
                            justifyContent: "center",
                            padding: 10,
                            borderRadius: 5,
                          }}
                        >
                          <Text
                            style={[
                              AppFontStyle.BOLD_ANYBODY_14,
                              {
                                color: AppColors.white,
                              },
                            ]}
                          >
                            1 VS 1
                          </Text>
                        </View>
                      </View>
                      <View
                        style={{
                          gap: 3,
                        }}
                      >
                        <Text
                          style={[
                            AppFontStyle.REGULAR_ANYBODY_12,
                            {
                              color: AppColors.white,
                            },
                          ]}
                        >
                          Game
                        </Text>
                        <View
                          style={{
                            backgroundColor: AppColors.black,
                            alignItems: "center",
                            justifyContent: "center",
                            padding: 10,
                            borderRadius: 5,
                          }}
                        >
                          <Text
                            style={[
                              AppFontStyle.BOLD_ANYBODY_14,
                              {
                                color: AppColors.white,
                              },
                            ]}
                          >
                            {eventDetails?.gameTitle}
                          </Text>
                        </View>
                      </View>
                      <View
                        style={{
                          gap: 3,
                        }}
                      >
                        <Text
                          style={[
                            AppFontStyle.REGULAR_ANYBODY_12,
                            {
                              color: AppColors.white,
                            },
                          ]}
                        >
                          Device
                        </Text>
                        <View
                          style={{
                            backgroundColor: AppColors.black,
                            alignItems: "center",
                            justifyContent: "center",
                            padding: 10,
                            borderRadius: 5,
                          }}
                        >
                          <Text
                            style={[
                              AppFontStyle.BOLD_ANYBODY_14,
                              {
                                color: AppColors.white,
                              },
                            ]}
                          >
                            {eventDetails?.device}
                          </Text>
                        </View>
                      </View>
                      <View
                        style={{
                          gap: 3,
                        }}
                      >
                        <Text
                          style={[
                            AppFontStyle.REGULAR_ANYBODY_12,
                            {
                              color: AppColors.white,
                            },
                          ]}
                        >
                          Gamer id
                        </Text>
                        <View
                          style={{
                            backgroundColor: AppColors.black,
                            alignItems: "center",
                            justifyContent: "center",
                            padding: 10,
                            borderRadius: 5,
                          }}
                        >
                          <Text
                            style={[
                              AppFontStyle.BOLD_ANYBODY_14,
                              {
                                color: AppColors.white,
                              },
                            ]}
                          >
                            {eventDetails?.gamerID?.organiser || "N/A"}
                          </Text>
                        </View>
                      </View>
                    </View>
                    {/* Game Rules and Description Section */}
                    <View
                      style={{
                        backgroundColor: AppColors.purple_453B50,
                        display: "flex",
                        flexDirection: "row",
                        padding: 10,
                        borderRadius: 10,
                        marginBottom: 10,
                        gap: 5,
                      }}
                    >
                      <View>
                        <ImageComponent
                          url={eventDetails?.gameImage}
                          style={{
                            width:
                              deviceSize === DEVICE_SIZES.XS ||
                                deviceSize === DEVICE_SIZES.SM
                                ? 123
                                : 115,
                            height:
                              deviceSize === DEVICE_SIZES.XS ||
                                deviceSize === DEVICE_SIZES.SM
                                ? 141
                                : 125,
                            marginTop: 10,
                            borderRadius: 20,
                            resizeMode: "contain",
                          }}
                        />
                      </View>
                      <View
                        style={{
                          marginTop: 10,
                          gap: 5,
                          width: 575,
                        }}
                      >
                        <Text
                          style={[
                            AppFontStyle.BOLD_ANYBODY_14,
                            {
                              color: AppColors.white,
                            },
                          ]}
                        >
                          Rules & Description:
                        </Text>
                        <Text
                          style={[
                            AppFontStyle.REGULAR_ANYBODY_12,
                            {
                              color: AppColors.white,
                            },
                          ]}
                        >
                          {eventDetails?.description ||
                            "No description available."}
                        </Text>
                      </View>
                    </View>

                    {/* Buttons positioned below description when details are shown */}
                    <View
                      style={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginTop: 15,
                        paddingHorizontal: 5,
                      }}
                    >
                      <TouchableOpacity
                        style={{
                          backgroundColor: AppColors.purple_453B50,
                          borderWidth: 1,
                          borderColor: AppColors.white,
                          borderRadius: 3,
                          padding: 8,
                          flexDirection: "row",
                          gap: 3,
                          alignItems: "center",
                        }}
                        onPress={() => handleActionPress("negotiate")}
                      >
                        <ImageComponent
                          url={AppImages.icNotificationMessage}
                          style={{
                            width: 20,
                            height: 20,
                          }}
                        />
                        <Text
                          style={[
                            AppFontStyle.REGULAR_ANYBODY_12,
                            {
                              color: AppColors.white,
                            },
                          ]}
                        >
                          Negotiate Terms
                        </Text>
                      </TouchableOpacity>
                      <TouchableOpacity
                        style={styles.chatButton}
                        onPress={() => setShowDetails(!showDetails)}
                      >
                        <Text style={styles.chatButtonText}>Hide Details</Text>
                      </TouchableOpacity>
                    </View>
                  </>
                )}
              </>
            )}

            <View style={styles.separator} />
          </ScrollView>

          <View style={styles.buttonWrapper}>
            {showCreateLoader ? (
              <View
                style={{
                  width: "100%",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Skeletons
                  height={53}
                  width={
                    deviceSize === DEVICE_SIZES.XS ||
                      deviceSize === DEVICE_SIZES.SM
                      ? "129px"
                      : "334px"
                  }
                />
                <Skeletons
                  height={53}
                  width={
                    deviceSize === DEVICE_SIZES.XS ||
                      deviceSize === DEVICE_SIZES.SM
                      ? "129px"
                      : "334px"
                  }
                />
              </View>
            ) : (
              <>
                <TouchableOpacity
                  style={[
                    styles.acceptRejectButtonStyle,
                    {
                      backgroundColor: AppColors.black,
                      borderWidth: 2,
                      borderColor: AppColors.white,
                    },
                  ]}
                  onPress={() => handleActionPress("reject")}
                >
                  <Text
                    style={[
                      styles.buttonText,
                      {
                        color: AppColors.white,
                      },
                    ]}
                  >
                    Reject
                  </Text>
                </TouchableOpacity>

                <TouchableOpacity
                  style={[
                    styles.acceptRejectButtonStyle,
                    {
                      backgroundColor: AppColors.appGreenColor_51AF07,
                    },
                  ]}
                  onPress={() => handleActionPress("accept")}
                >
                  <Text style={styles.buttonText}>Accept</Text>
                </TouchableOpacity>
              </>
            )}
          </View>
        </View>
      </View>
    </Modal>
  );
}

export default EventSharePopup;
